// import { EventBus } from '@/main'
import store from '@/store'
import message from 'ant-design-vue/lib/message';
// import { wsurl } from '@/utils/ajax'
let jumpTik
let reLink
let notNeedLink = true
let jumpNoNum = 0
let ljUrls = ''
let ws = null
export default function WebSocketInit(ljUrl, type) {
  ljUrls = ljUrl
  if (notNeedLink == true) {
    notNeedLink = false
    let wst = ''
    if (document.location.protocol === 'https:') {
      wst = 'wss://'
    } else {
      wst = 'ws://'
    }
    // if (type) {
    //   if (ws !== null) {
    //     console.log('关闭已有的 WebSocket 连接');
    //     ws.close(); // 关闭已有的 WebSocket
    //   }
    // }
    // const url = 'ws://yhrl.tzgcs360.com' + ljUrl
    const url = wst + 'www.yhrl.com' + ljUrl
    // const url = wst + '192.168.130.155:8203' + ljUrl
    ws = new WebSocket(url)
    ws.onopen = function (params) {
      console.log("客户端连接成功");
      if (reLink) {
        clearInterval(reLink);
      }
      //   // 向服务器发送消息
      // ws.send("hello");
    };

    ws.onclose = () => {
      console.log('WebSocket断开连接')
      notNeedLink = true
      let duankai = window.localStorage.getItem("duankai");
      if (duankai == 1) {
        clearInterval(reLink);
      }
      if (duankai == 2) {
        reLinkTask()
        if (type==2) {
          message.error("连接失败，请刷新页面！");
        }else{
          message.error("聊天室断开连接，可能导致发送信息失败，请刷新页面！");
        }
      }
    }

    ws.onerror = err => {
      console.log(err);

      notNeedLink = true
      if (jumpTik) clearInterval(jumpTik)
      let duankai = window.localStorage.getItem("duankai");
      if (duankai != 1) {
        clearInterval(reLink);
        reLinkTask()
      }
      if (duankai == 1) {
        clearInterval(reLink);
      }
    }

    ws.onmessage = res => {
      const data = JSON.parse(res.data)
      window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
          data: data
        }
      }))
      // EventBus.$emit('updatelist', data)
    }
    window.ws1 = ws
    // store.commit('SET_WS', ws)
  }
}

function reLinkTask() {
  // console.log(notNeedLink);
  // if (!notNeedLink ) {
  reLink = setInterval(() => {
    console.log('重新连接WebSocket')
    WebSocketInit(ljUrls)
  }, 5000)
  // }
}